import React from 'react';
import { AiOutlineLeft, AiOutlineRight, AiOutlineVerticalLeft, AiOutlineVerticalRight } from 'react-icons/ai';

const PaginationComponent = ({
    pages,
    handleChangeRowsPerPage,
    handleFirstPageButtonClick,
    handleBackButtonClick,
    handleNextButtonClick,
    handleLastPageButtonClick
}: any) => {
    const totalPages = pages?.TotalPages || 1;
    const currentPage = pages?.PageNumber || 1;
    const pageSize = pages?.PageSize || 10;
    const totalCount = pages?.TotalCount;
    return (
        <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
                Rows per page:
                <select
                    value={handleChangeRowsPerPage ? pageSize : 10}
                    onChange={e => handleChangeRowsPerPage && handleChangeRowsPerPage(Number(e.target.value))}
                    className="border p-1 rounded"
                    disabled={!handleChangeRowsPerPage}
                >
                    {[10, 25, 50, 75, 100].map(size => (
                        <option key={size} value={size}>
                            {size}
                        </option>
                    ))}
                </select>
            </div>
            <div className="flex items-center gap-2">
                <button
                    className={`p-2 ${currentPage <= 1 ? 'text-gray-400' : 'text-black'}`}
                    onClick={handleFirstPageButtonClick}
                    disabled={currentPage <= 1}
                >
                    <AiOutlineVerticalRight className='text-xl' />
                </button>
                <button
                    className={`p-2 ${currentPage <= 1 ? 'text-gray-400' : 'text-black'}`}
                    onClick={handleBackButtonClick}
                    disabled={currentPage <= 1}
                >
                    <AiOutlineLeft className='text-xl' />
                </button>
                <span className="font-medium">
                    Page <strong>{currentPage}</strong> - <strong>{totalPages}</strong> of <strong>{totalCount}</strong>
                </span>
                <button
                    className={`p-2 ${currentPage >= totalPages ? 'text-gray-400' : 'text-black'}`}
                    onClick={handleNextButtonClick}
                    disabled={currentPage >= totalPages}
                >
                    <AiOutlineRight className='text-xl' />
                </button>
                <button
                    className={`p-2 ${currentPage >= totalPages ? 'text-gray-400' : 'text-black'}`}
                    onClick={handleLastPageButtonClick}
                    disabled={currentPage >= totalPages}
                >
                    <AiOutlineVerticalLeft className='text-xl' />
                </button>
            </div>
        </div>
    );
};

export default PaginationComponent;